<template>
    <transition :name="animation" mode="out-in">
        <div v-if="loading" key="loading">
            <slot name="loading">
                <div class="card bg-info">
                    <loading-animation/>
                    Please wait while loading data from the server.
                </div>
            </slot>
        </div>

        <div v-else-if="error" key="error">
            <slot name="error">
                <div class="card bg-danger">
                    <error-icon/>
                    Failed to load data from the server.
                </div>
            </slot>
        </div>

        <div v-else-if="!url" key="no-url">
            <slot name="no-url">
                <div class="card bg-danger">
                    <error-icon/>
                    Please provide url
                </div>
            </slot>
        </div>

        <div v-else key="response">
            <slot :response="response">
                {{ response }}
            </slot>
        </div>
    </transition>
</template>

<script>
import axios from 'secure-axios';

export default {
    name : 'ajax-view',

    props : {
        ajaxMethod : { type : String, default : 'form' },

        animation : { type : String, default : 'fade' },
        params    : { type : Object, required : false },
        url       : { type : String, required : true }
    },

    watch : {
        url : function () {
            this.reset();
            this.loadData();
        },

        params : function () {
            this.reset();
            this.loadData();
        }
    },

    data () {
        return {
            loading  : true,
            loaded   : false,
            error    : false,
            response : {}
        };
    },

    created () {
        if (!this.loaded) {
            this.loadData();
        }
    },

    methods : {
        reset () {
            this.loaded = false;
            this.response = {};
        },

        reload () {
            this.reset();
            this.loadData();
        },

        showLoading () {
            this.reset();
            this.loading = true;
            this.error = false;
        },

        setResponse (response) {
            this.loadDataSuccess(response);
        },

        loadData () {
            const that = this;
            const url = this.url;
            const params = this.params;

            if (!url) {

            }

            that.loading = true;
            that.error = false;

            let request;

            if (params) {
                request = axios.perform(url, params, this.ajaxMethod);
            } else {
                request = axios.get(url);
            }

            request.then(function (response) {
                that.loadDataSuccess(response);
            }).catch(function () {
                that.loadDataFailed();
            });
        },
        loadDataSuccess (response) {
            this.loaded = true;
            this.loading = false;
            this.error = false;
            this.response = response.data;
            this.$emit('success', this.response);
        },
        loadDataFailed () {
            this.loading = false;
            this.error = true;
            this.$emit('error');
        }
    }
};
</script>
